import { combineReducers } from 'redux';

import progress from './reducers/progressReducer';
import scene from './reducers/sceneReducer';
import score from './reducers/scoreReducer';
import dragdrop from './reducers/dragdropReducer';
import question from './reducers/questionReducer';

const wordbotsReducers = combineReducers({
  progress,
  scene,
  score,
  dragdrop,
  question,
});

export default wordbotsReducers;
